import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import PoliticianProfile from './pages/PoliticianProfile';
import PartyProfile from './pages/PartyProfile';
import SearchPage from './pages/SearchPage';
import ComparePage from './pages/ComparePage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="politico/:id" element={<PoliticianProfile />} />
        <Route path="partido/:id" element={<PartyProfile />} />
        <Route path="buscar" element={<SearchPage />} />
        <Route path="comparar/:id1/:id2" element={<ComparePage />} />
      </Route>
    </Routes>
  );
}

export default App;
